import type { AttachmentSelectDto } from '@@types/api.types';

export const NO_TECHNOLOGY_IMAGES_MESSAGE = 'No technology images yet.';

export const sortTechnologyImages = <T extends Pick<AttachmentSelectDto, 'createdAt' | 'featured' | 'position'>>(
  images: T[],
): T[] => {
  return [...images].sort((leftImage, rightImage) => {
    if (leftImage.featured !== rightImage.featured) {
      return leftImage.featured ? -1 : 1;
    }

    if (leftImage.position !== rightImage.position) {
      return leftImage.position - rightImage.position;
    }

    return leftImage.createdAt.localeCompare(rightImage.createdAt);
  });
};
